module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-16.42e57a39.jpg";